import React, { Component } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

class About extends Component {
  componentDidMount() {
    AOS.init({ duration: 2000 });
  }
  render() {
    return (
      <div className="about-section">
        <div
          data-aos="fade-up"
          data-aos-anchor=".header-container"
          data-aos-anchor-placement="bottom-center"
          data-aos-duration="1000"
          className="heading"
        >
          About
        </div>
        <div
          data-aos="fade-up"
          data-aos-anchor=".header-container"
          data-aos-anchor-placement="bottom-center"
          className="helloimg"
        >
          <img src="https://66.media.tumblr.com/85649825a5392e8cd3d832a4ed1534f5/tumblr_njpy6zj5by1tq4of6o1_500.gif"></img>
        </div>
        <div
          className="about-content"
          data-aos="fade-up"
          data-aos-anchor=".header-container"
          data-aos-anchor-placement="bottom-center"
        >
          I am currently persuing B.tech in Electronics communication from
          <b class="highlight"> IIT BHU Varanasi</b> 😎.I am interested in
          <b class="highlight"> data structures and algorithms</b>.I am a
          <b class="highlight"> competitive programmer</b>❤.I also have
          knowledge in
          <b class="highlight"> machine learning and computer vision</b>
          🤖🤖.Currently I am exploring the field of web development🌈.I am also
          an upcoming intern at
          <b class="highlight"> Microsoft.</b>
        </div>
      </div>
    );
  }
}

export default About;
